import React, { PureComponent, ReactNode } from "react";
import Navbar from "../../../components/CustomNav/CustomNav.Component";

import { currentUser } from "src/common/services";
import { Container } from "src/pages/Teachers/TeacherMenu.styles";
import { PickerHeader } from "../CourseDetails/CourseDetails.styles";
import { HeaderRow } from "../DataCentre.styles";
import DatePicker from "../../../components/DatePicker/DatePickerComponent";
import { toast } from "react-toastify";
import withServices from "../../../HOCs/withServices";
import { LearnersRow, GradientList, GradientListItem } from "../School/QuickGlance/QuickGlance.styles";

interface Props {
  history: any;
  services: any;
}
interface State {
  startDateObj: unknown;
  endDateObj: unknown,
  leastActiveLearners: [],
  inactiveLearners: [],
  startDate: string,
  endDate: string,
  loading: boolean
} 

const learners = [
    "Breburn Learner 1",
     "Breburn Learner 2",
     "Breburn Learner 3",
     "Breburn Learner 4",
     "Breburn Learner 5",
     "Breburn Learner 6",
    ];


class LearnerActivity extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      startDateObj: null,
      endDateObj: null,
      leastActiveLearners: [],
      inactiveLearners: [],
      startDate: '',
      endDate: '',
      loading: false
    };

    this.fetchLearnerActivity = this.fetchLearnerActivity.bind(this);
  }

  public onMenuItemClick = (path) => {
    if (path === "helpcenter") {
      window.open("https://myperformancelearning.com/help", "_blank");
      return;
    }
    this.props.history.push(path);
  };

  public onStartDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ startDateObj: dateObj, startDate: date });
  };

  public onEndDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ endDateObj: dateObj, endDate: date });
  };

  public async fetchLearnerActivity() {
    this.setState({loading: true});
    const {startDate, endDate} = this.state;
       const {
         services: { teachersAPI },
       } = this.props;
     if (!startDate.length || !endDate.length) {
       toast.warn("Please make sure you have picked the correct date ranges");
       return;
     }
     const [inactiveRes, leastActiveRes]= await Promise.all([teachersAPI.getLeastActiveLearners(startDate, endDate), teachersAPI.getInactiveLearners(startDate, endDate)]);

     console.log({inactiveRes, leastActiveRes});
     this.setState({loading: false });
  }

  public onLogout = () => {
    this.props.history.replace("/login");
  };

  public render(): ReactNode {
    return (
      <Container>
        <Navbar logoutParent={this.onLogout} />
        <h1 className="menu-heading">
          Hey <span>{currentUser()}</span>
        </h1>
        <PickerHeader>
          <HeaderRow>
            <DatePicker
              value={this.state.startDateObj}
              onChange={this.onStartDateChange}
              placeholder="Pick a start date"
            />
            <DatePicker
              value={this.state.endDateObj}
              onChange={this.onEndDateChange}
              placeholder="Pick an end date"
            />
            <button
              onClick={this.fetchLearnerActivity}
              className="button green-button go-action"
            >
              GO
            </button>
          </HeaderRow>
        </PickerHeader>
        <LearnersRow>
            <div className="learners-row">
                 <GradientList>
            <h3 className="list-title">Inactive Learners</h3>

            {learners.map((learner, i) => (
              <GradientListItem
                highlightColor={`#ff0033`}
                key={`top5_${learner}_${i}`}
              >
                {learner}
              </GradientListItem>
            ))}
          </GradientList>
          <GradientList>
            <h3 className="list-title">Least Active Learners</h3>

            {learners.map((learner, i) => (
              <GradientListItem
                highlightColor={`#ff7a03`}
                key={`top5_${learner}_${i}_least`}
              >
                {learner}
              </GradientListItem>
            ))}
          </GradientList>
            </div>
         
        </LearnersRow>
      </Container>
    );
  }
}

export default withServices(LearnerActivity);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Teacher/TeacherLearnerActvity.Component.tsx